import React from 'react'

const InfoIcon = ({height, width, color}: {height?: string; width?: string; color?: string}) => {
  return (
    <svg
      width={width || '24'}
      height={height || '24'}
      viewBox='0 0 16 16'
      fill={color || '#666666'}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g id='icons8-info 1' clipPath='url(#clip0_1346_2248)'>
        <path
          id='Vector'
          d='M8 0.75C4 0.75 0.75 4 0.75 8C0.75 12 4 15.25 8 15.25C12 15.25 15.25 12 15.25 8C15.25 4 12 0.75 8 0.75ZM8 1.5C11.5875 1.5 14.5 4.4125 14.5 8C14.5 11.5875 11.5875 14.5 8 14.5C4.4125 14.5 1.5 11.5875 1.5 8C1.5 4.4125 4.4125 1.5 8 1.5ZM8 3.75C7.70163 3.75 7.41548 3.86853 7.2045 4.0795C6.99353 4.29048 6.875 4.57663 6.875 4.875C6.875 5.17337 6.99353 5.45952 7.2045 5.6705C7.41548 5.88147 7.70163 6 8 6C8.29837 6 8.58452 5.88147 8.7955 5.6705C9.00647 5.45952 9.125 5.17337 9.125 4.875C9.125 4.57663 9.00647 4.29048 8.7955 4.0795C8.58452 3.86853 8.29837 3.75 8 3.75ZM8 7.375C7.375 7.375 6.875 7.875 6.875 8.5V11.5C6.875 12.125 7.375 12.625 8 12.625C8.625 12.625 9.125 12.125 9.125 11.5V8.5C9.125 7.875 8.625 7.375 8 7.375Z'
          fill={color || '#666666'}
        />
      </g>
      <defs>
        <clipPath id='clip0_1346_2248'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default InfoIcon
